import { styled } from '@stitches/react';

const ArrowButtonContainer = styled('button', {
  padding: '$3 $1',
  backgroundColor: '#FFFFFF',
  cursor: 'pointer',
  border: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'none',
  color: 'inherit',
  font: 'inherit',
  outline: 'inherit',
  variants: {
    position: {
      left: {
        borderLeft: '1px solid $borderMultiSportColor',
        rotate: '180deg',
      },
      right: {
        borderLeft: '1px solid $borderMultiSportColor',
        borderRight: '1px solid $borderMultiSportColor',
      },
    },
  },
});

export const SMPArrowButton = ({ onClick, variant }: { onClick: VoidFunction; variant: 'left' | 'right' }) => {
  return (
    <ArrowButtonContainer position={variant} onClick={onClick}>
      <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g id='arrow_forward_ios'>
          <mask id='mask0_1838_194719' maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24'>
            <rect id='Bounding box' width='24' height='24' fill='#D9D9D9' />
          </mask>
          <g mask='url(#mask0_1838_194719)'>
            <path
              id='arrow_forward_ios_2'
              d='M8.025 22L6.25 20.225L14.475 12L6.25 3.775L8.025 2L18.025 12L8.025 22Z'
              fill='var(--colors-accentPrimaryBgColor)'
            />
          </g>
        </g>
      </svg>
    </ArrowButtonContainer>
  );
};
